import './index.css'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Typography, Box } from '@mui/material'
import actionTypes from 'store/actions'

import DropZone from 'components/Common/TableCells/DropZone'

import DocumentFileName from './components/DocumentFileName'
import DocumentEffectiveDate from './components/DocumentEffectiveDate'
import DocumentRemoveButton from './components/DocumentRemoveButton'
import Button from 'components/Common/Button'
import { PRIMARY_BUTTON, DISABLED_BUTTON, SECONDARY_BUTTON } from 'themes/theme'

import { VaultAPI } from 'api'

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const ItemTypes = () => ['Applicable SOPs', 'Business Owners Policy','By Laws','Certificate of Business', 'Directors and Owners Policy',
                           'EIN','Financial Info','Income Tax Return','Industry Specific Policy','Limited Liability Policy',
                           'NAICS','Other']


const tableHeaders = [
  {
    field: 'fileName',
    title: 'File Name',
    width: '280px',
    content: ""
  },
  {
    field: 'documentType',
    title: 'Document type',
    width: '320px',
    content: <span style={{color: "#D14343"}}>*</span>
  },
  {
    field: 'description',
    title: 'Description',
    width: '320px',
    content: <span style={{color: "#D14343"}}>*</span>
  },
  {
    field: 'effectiveDate',
    title: 'Effective As Of',
    width: '120px',
    content: <span style={{color: "#D14343"}}>*</span>
  },
  {
    field: 'status',
    title: '',
    width: '80px',
  },
  {
    field: '',
    title: '',
    width: '30px',
  },
]

const VaultAddDocumentPopUp = props => {
  const dispatch = useDispatch()

  const readyToUpload = useSelector(state => state.vaultReducer.readyToUpload)
  const vaultInfo = useSelector(state => state.vaultReducer.vaultSummary)
  // const vaultInfo = useSelector(state => state.apiResponseReducers.dashboardInfo?.vault_info)
  const draftDocuments = useSelector(state => state.vaultReducer.draftDocuments)
  const uploadingStatus = useSelector(state => state.vaultReducer.uploadingStatus)

  useEffect(() => {
    if (uploadingStatus === 3) {
      props.onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadingStatus])

  const onSave = () => {
    VaultAPI.submitDraftDocuments(dispatch, vaultInfo?.vault_id, draftDocuments)
  }

  const removeDraftFile = artifactId => {
    dispatch({ type: actionTypes.VAULTREMOVEDRAFTDOCUMENT, payload: { id: artifactId } })
  }

  const onFileAdded = draftDocuments => {
    dispatch({ type: actionTypes.VAULTDRAFTDOCUMENTSSADDED, payload: { draftDocuments } })
  }

  const onDateChange = (event, id) => {
    if (event.target.validity.valid === false) return;

    dispatch({
      type: actionTypes.VAULTUPDATEDRAFTDOCUMENT,
      payload: { id, effectiveDate: event.target.value.getTime() },
    })
  }

  const onItemTypeChange = (event, value, id) => {
    dispatch({ type: actionTypes.VAULTUPDATEDRAFTDOCUMENT, payload: { id, documentType: value } })
  }

  const onDescriptionChange = (event, id) => {
    dispatch({ type: actionTypes.VAULTUPDATEDRAFTDOCUMENT, payload: { id, description: event.target.value } })
  }

  return (
    <Dialog>
      <Box textAlign='center' marginTop='40px' marginBottom='30px'>
        <Typography variant='h5' fontWeight='600' fontsize='24px' color='#25245F' >Upload Documents</Typography>
      </Box>
      <div className="vault-add-document">
        <DropZone onAdd={onFileAdded} />
        <div className="vault-add-document-table-container">
          <div className="vault-add-document-table-wrapper">
          {draftDocuments.map((document, index) => (
            <table key={'draftDocument' + document.id} className={'vault-add-document-table color-primary text-normal'}>
              <thead>
                <tr>
                  {tableHeaders.map(e => (
                    <th key={e.field} style={{ width: e.width, fontWeight: '500', zIndex: '0' }}>
                      {e.title}{e.content}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody> 
                  <tr>
                    <td style={{ width: tableHeaders[0].width }}>
                      <DocumentFileName id={document.id} value={document['fileName']} />
                    </td>
                    <td style={{ maxWidth: tableHeaders[1].width }}>
                         <Autocomplete
                           ListboxProps={{ style: { maxHeight: 100, overflow: 'auto' } }}
                           disablePortal
                           options={ItemTypes()}
                           sx={{ width: 290,
                            "&.MuiAutocomplete-root .MuiOutlinedInput-root":{
                              padding:"6.5px !important"
                            },  
                            }}
                           onChange={(event,value) => onItemTypeChange(event,value, document.id)}
                           renderInput={(params) => <TextField {...params}/>}
                           value={document['documentType']}
                          />
                    </td>
                    <td style={{ width: tableHeaders[2].width }}>
                      <textarea
                        className="vault-add-document-table-description-cell"
                        maxLength="60"
                        rows="2"
                        value={document['description']}
                        placeholder="Description (Max 60 letters)"
                        onChange={e => onDescriptionChange(e, document.id)}
                        // onChange={e => {
                        //   const newDescriptions = { ...descriptions }
                        //   newDescriptions[document.id] = e.target.value
                        //   setDescriptions(newDescriptions)
                        // }}
                        {...props?.rest}
                      />
                    </td>
                    <td style={{ width: tableHeaders[3].width }}>
                      <DocumentEffectiveDate
                        id={document.id}
                        value={document['effectiveDate']}
                        onChange={onDateChange}
                      />
                    </td>

                    {/* <td style={{ width: tableHeaders[4].width }}>
                      <DocumentUploadingStatus id={document.id} value={document['status']} />
                    </td> */}
                    <td style={{ width: tableHeaders[5].width }}>
                      <DocumentRemoveButton id={document.id} value={document['status']} onClick={removeDraftFile} />
                    </td>
                  </tr>            
              </tbody>
            </table>
            ))}
          </div>
          <div className="vault-add-table-footer">
            <Button
              type={SECONDARY_BUTTON}
              onClick={props.onClose}
              sx={{ marginRight: '5px', width:'250px' }}
            >
              Cancel
            </Button>
            <Button 
               onClick={onSave} 
               sx={{ width:'250px' }} type={readyToUpload || !uploadingStatus === 3 ? PRIMARY_BUTTON : DISABLED_BUTTON} 
               loading={uploadingStatus === 2}
              >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default VaultAddDocumentPopUp
